import React, { useMemo } from "react"

import { cn, ColorSwatch } from "@coval/ui"

import { getDefaultTagColor } from "../constants/tag-colors"
import { normalizeTags } from "../utils/tagNormalization"

interface TagDotListProps {
  tags?: string[] | null
  tagColorMap?: Record<string, string | null | undefined>
  className?: string
}

/**
 * Every tag on its own line, as a color dot plus its name. The dot carries the
 * tag's identity, so the name needs no chip behind it and a long list reads as
 * a list instead of a crowded row.
 */
export const TagDotList: React.FC<TagDotListProps> = ({
  tags = [],
  tagColorMap = {},
  className,
}) => {
  const currentTags = useMemo(() => normalizeTags(tags ?? []), [tags])

  if (currentTags.length === 0) {
    return null
  }

  return (
    <div className={cn("flex min-w-0 flex-col gap-1.5", className)}>
      {currentTags.map((tag) => (
        <div key={tag} className="flex min-w-0 items-center gap-1.5">
          <ColorSwatch
            color={tagColorMap[tag] || getDefaultTagColor(tag)}
            className="size-2.5"
          />
          <span className="truncate" title={tag}>
            {tag}
          </span>
        </div>
      ))}
    </div>
  )
}
